import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { Subscription } from 'rxjs';

import { ToastService, IToast } from '../toast.service';

interface IToastTimeout extends IToast {
  timeout?: any;
}

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  @HostBinding('class')
  public classes = 'fixed-bottom mb-2 d-flex justify-content-center align-items-center';

  public toasts: IToastTimeout[] = [];

  constructor(
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.subscriptions.push(this.toastService.toasts.subscribe(toast => this.add(toast)));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private add(toast: IToastTimeout) {
    this.toasts.push(toast);
    if (toast.duration) {
      toast.timeout = setTimeout(() => this.dismiss(toast), toast.duration);
    }
  }

  public dismiss(toast: IToastTimeout) {
    this.toasts.splice(this.toasts.findIndex(val => val.id === toast.id), 1);
  }
}
